<!-- =========================================================================================
File Name: RegisterJWT.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div v-if="isRegisterJwt" class="min-h-re2">
      <form @submit="registerUserJWt">
        <div class="vx-card__title mb-4">
          <h4 class="mb-4">Activar cuenta</h4>
          <p>Rellena los siguientes datos para activar tu cuenta.</p>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <a
              class="btn-google"
              href="https://api.digitafirma.com/oauth2/authorize/google?redirect_uri=https://app.verificamex.com/signature/oauth2/redirect">
              <div class="google-content">
                <div class="logo">
                  <svg width="2443" height="2500" viewBox="0 0 256 262" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"><path d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027" fill="#4285F4"/><path d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1" fill="#34A853"/><path d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782" fill="#FBBC05"/><path d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251" fill="#EB4335"/></svg>
                </div>
                <p>Acceder con Google</p>
              </div>
            </a>
          </div>

          <div class="vx-col w-full lg:w-1/2">
            <a
              class="btn-google"
              href="https://api.digitafirma.com/oauth2/authorize/linkedin?redirect_uri=https://app.verificamex.com/signature/oauth2/redirect">
              <div class="google-content">
                <div class="logo">
                  <svg height="2500" width="2490" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><g fill="none"><path d="M0 18.338C0 8.216 8.474 0 18.92 0h218.16C247.53 0 256 8.216 256 18.338v219.327C256 247.79 247.53 256 237.08 256H18.92C8.475 256 0 247.791 0 237.668V18.335z" fill="#069"/><path d="M77.796 214.238V98.986H39.488v115.252H77.8zM58.65 83.253c13.356 0 21.671-8.85 21.671-19.91-.25-11.312-8.315-19.915-21.417-19.915-13.111 0-21.674 8.603-21.674 19.914 0 11.06 8.312 19.91 21.169 19.91h.248zM99 214.238h38.305v-64.355c0-3.44.25-6.889 1.262-9.346 2.768-6.885 9.071-14.012 19.656-14.012 13.858 0 19.405 10.568 19.405 26.063v61.65h38.304v-66.082c0-35.399-18.896-51.872-44.099-51.872-20.663 0-29.738 11.549-34.78 19.415h.255V98.99H99.002c.5 10.812-.003 115.252-.003 115.252z" fill="#fff"/></g></svg>
                </div>
                <p>Acceder con Linkedin</p>
              </div>
            </a>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <vs-input
              v-validate="'required|alpha_dash|min:3'"
              data-vv-as="nombres"
              data-vv-validate-on="blur"
              label-placeholder="Nombre(s)"
              name="name"
              autocomplete="off"
              placeholder="Nombre(s)"
              v-model="name"
              class="w-full" />
            <span class="text-danger">{{ errors.first('name') }}</span>
          </div>

          <div class="vx-col w-full lg:w-1/2">
            <vs-input
              v-validate="'required|alpha_dash|min:3'"
              data-vv-as="apellidos"
              data-vv-validate-on="blur"
              label-placeholder="Apellidos"
              name="last_name"
              autocomplete="off"
              placeholder="Apellidos"
              v-model="last_name"
              class="w-full" />
            <span class="text-danger">{{ errors.first('last_name') }}</span>
          </div>
        </div>

        <vs-input
          v-validate="'required|email'"
          data-vv-validate-on="blur"
          name="email"
          type="email"
          label-placeholder="Correo"
          placeholder="Correo"
          autocomplete="off"
          v-model="email"
          class="w-full mt-6" />
        <span class="text-danger">{{ errors.first('email') }}</span>

        <vs-input
          data-vv-validate-on="blur"
          name="coupon"
          type="text"
          label-placeholder="Ingresa un cupón (opcional)"
          placeholder="Ingresa un cupón (opcional)"
          autocomplete="off"
          v-model="coupon"
          class="w-full mt-6"
        />
        <span class="text-danger">{{ errors.first('coupon') }}</span>

        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <vs-input
              ref="password"
              :type="type"
              data-vv-validate-on="blur"
              v-validate="'required|min:6|max:16'"
              data-vv-as="contraseña"
              name="password"
              label-placeholder="Password"
              placeholder="Contraseña"
              autocomplete="off"
              v-model="password"
              class="w-full mt-6" />
            <div class="form-control-position field-icon">
              <a @click="showPassword">
                <feather-icon :icon="icon" class="top-4 " svgClasses="w-5 h-5 icon-color"></feather-icon>
              </a>
            </div>
            <span class="text-danger">{{ errors.first('password') }}</span>
          </div>


          <div class="vx-col w-full lg:w-1/2">
            <vs-input
              :type="type"
              v-validate="'required|min:6|max:16|confirmed:password'"
              data-vv-validate-on="blur"
              data-vv-as="confirmación de contraseña"
              name="confirm_password"
              autocomplete="off"
              label-placeholder="Confirm Password"
              placeholder="Repetir contraseña"
              v-model="password_confirmation"
              class="w-full mt-6" />
            <div class="form-control-position field-icon">
              <a @click="showPassword">
                <feather-icon :icon="icon" class="top-4 " svgClasses="w-5 h-5 icon-color"></feather-icon>
              </a>
            </div>
            <span class="text-danger">{{ errors.first('confirm_password') }}</span>
          </div>

        </div>

        <div>
          <input
            type="checkbox"
            v-model="isTermsConditionAccepted"
            name="terms"
            v-validate="'required'"
            data-vv-as="términos y condiciones"
            class="d-none">
          <vs-checkbox
            v-model="isTermsConditionAccepted"
            class="mt-6 d-inline-b"
            name="terms"
          ></vs-checkbox>
          <span class="terms">Acepto los <a target="_blank" href="https://verificamex.com/terminos-y-condiciones">Términos y Condiciones</a> del servicio.</span>
          <br><span class="text-danger">{{ errors.first('terms') }}</span>
        </div>
          <div>
            <input
              type="checkbox"
              v-model="isPrivacyNoticeAccepted"
              name="privacy"
              v-validate="'required'"
              data-vv-as="aviso de privacidad"
              class="d-none">
            <vs-checkbox
              v-model="isPrivacyNoticeAccepted"
              class="mt-2 d-inline-b"
              name="privacy"
            ></vs-checkbox>
            <span class="terms">Acepto el <a target="_blank" href="https://verificamex.com/aviso-de-privacidad">Aviso de Privacidad Integral</a> del servicio.</span>
            <br><span class="text-danger">{{ errors.first('privacy') }}</span>
          </div>
        <input type="submit" style="position: absolute; left: -9999px"/>
        <vs-button ref="loadableButton" id="button-with-loading" class="mt-6 vs-con-loading__container" :disabled="isSubmitted" @click="registerUserJWt" type="relief" vslor="primary">Registrar</vs-button>
        <vs-button  type="flat" to="/login" class="float-right mt-6" >Iniciar sesión</vs-button>
      </form>

    </div>

    <div v-if="isSuccess" class="min-h-re2">
      <div class="vx-card__title mb-4 pt-33p">
        <div class="center-y">
          <h2 class="mb-4">¡Gracias por registrarte!</h2>
          <h4 class="font-w-400 mt-5">Hemos enviado un correo electrónico a <span class="font-w-600 text-primary">{{ email }}</span> para verificar tu identidad. </h4>
          <h4 class="font-w-400 mt-5">En caso de que no lo hayas recibido ve a tu carpeta de Spam o vuelva a enviar otro correo con el siguiente botón.</h4>
          <vs-button ref="loadableButton" id="button-loading-resend" class="mt-6 vs-con-loading__container" :disabled="isSubmittedResendEmail" @click="resend_email" type="relief" vslor="primary">Reenviar correo</vs-button>
<!--          <vs-button @click="resend_email" class=" mt-6">Reenviar correo</vs-button>-->

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  data () {
    return {
      tabIndex: 1,
      icon: 'EyeIcon',
      type: 'password',
      name: '',
      last_name: '',
      email: '',
      password: '',
      coupon: '',
      password_confirmation: '',
      isTermsConditionAccepted: false,
      isPrivacyNoticeAccepted: false,
      isSubmitted: false,
      isSubmittedResendEmail: false,
      utmSource: "",
      utmMedium: "",
      utmCampaign: ""
    }
  },
  computed: {
    isRegisterJwt() {
      return this.tabIndex === 1;
    },
    isSuccess() {
      return this.tabIndex === 2;
    }
  },
  methods: {
    resend_email() {
      this.isSubmittedResendEmail = true;
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#button-loading-resend",
        scale: 0.45
      });
      this.$store.dispatch("account/resend_verification_email", {email: this.email})
      .then(
        () => {
          this.$vs.loading.close("#button-loading-resend > .con-vs-loading");
          this.isSubmittedResendEmail = false;
        },
        () => {
          this.$vs.loading.close("#button-loading-resend > .con-vs-loading");
          this.isSubmittedResendEmail = false;
        }
      )
    },
    toggleTab(index) {
      this.tabIndex = index;
    },
    setPhone(email) {
      this.email = email;
    },
    showPassword() {
      if(this.type === 'password') {
        this.type = 'text'
        this.icon = 'EyeOffIcon'
      } else {
        this.type = 'password'
        this.icon = 'EyeIcon'
      }
    },
    registerUserJWt (e) {
      if (e) {
        e.preventDefault();
      }
      this.$store.dispatch('alert/clear', {}, { root: true });
      this.isSubmitted = true;
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          // Proceed with form submission
          this.$vs.loading({
            background: 'primary',
            color: '#fff',
            container: "#button-with-loading",
            scale: 0.45
          });
          const user = {
            name: this.name,
            email: this.email,
            last_name: this.last_name,
            password: this.password,
            password_confirmation: this.password_confirmation,
            utm_source: this.utmSource,
            utm_campaign: this.utmCampaign,
            utm_medium: this.utmMedium,
            coupon: this.coupon
          }
          this.$store.dispatch('account/register', user)
            .then(() => {
              this.isSubmitted = false;
              this.$vs.loading.close("#button-with-loading > .con-vs-loading");
              this.toggleTab(2);
              fbq('track', 'DFRegisExiPix');
              gtag('event', 'DFRegisExiPix', {'method': 'DFRegisExiPix'});
            })
            .catch(error => {
              this.isSubmitted = false;
              this.$vs.loading.close("#button-with-loading > .con-vs-loading");
            })
        } else {
          this.$store.dispatch('alert/error', 'Ingrese los datos solicitados', { root: true });
          this.isSubmitted = false;
        }
      });
    }
  },
  mounted() {
    if (this.$route.query.utm_source) {
      this.utmSource = this.$route.query.utm_source
      Cookies.set('utm_source', this.utmSource)
    }
    if (this.$route.query.utm_medium) {
      this.utmMedium = this.$route.query.utm_medium
      Cookies.set('utm_medium', this.utmMedium)
    }
    if (this.$route.query.utm_campaign) {
      this.utmCampaign = this.$route.query.utm_campaign
      Cookies.set('utm_campaign', this.utmCampaign)
    }
  }
}
</script>

<style lang="scss">
.d-inline-b {
  display: inline-block!important;
}
.terms{
  position: relative;
  top: -5px;
}

.is-invalid {
  border-color: red !important;
}
.text-danger {
  color: red;
  font-size: 12px;
}
</style>
